/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Stat_GeneratedInputs */

const en_fw_bm_stat_generated = /** @type {(inputs: Fw_Bm_Stat_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generated`)
};

const id_fw_bm_stat_generated = /** @type {(inputs: Fw_Bm_Stat_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dihitung`)
};

/**
* | output |
* | --- |
* | "Generated" |
*
* @param {Fw_Bm_Stat_GeneratedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_stat_generated = /** @type {((inputs?: Fw_Bm_Stat_GeneratedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Stat_GeneratedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_stat_generated(inputs)
	return en_fw_bm_stat_generated(inputs)
});